import { render, staticRenderFns } from "./SummerPage.vue?vue&type=template&id=215f81a4&scoped=true&"
import script from "./SummerPage.vue?vue&type=script&lang=js&"
export * from "./SummerPage.vue?vue&type=script&lang=js&"
import style0 from "./SummerPage.vue?vue&type=style&index=0&id=215f81a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215f81a4",
  null
  
)

export default component.exports